import VWMeasurements from '../vw-measurements';
import RaidLoad from '../raid/load';
import RoutePoint from './point';
import RouteStopover from './stopover';
import { unixTimeToStr } from '~/utils/date';

export default class RouteLeg {
  data = null;

  departure = null;
  arrival = null;

  stopovers = [];

  capacity = {
    available: null,
    airplane: null,
    code: null,
    load: null,
  };

  dictionary = {};

  constructor (data) {
    this.data = data;
    this.dictionary = data.dictionary;

    this.departure = new RoutePoint(data.departure, data.waitTime, 'departure', this.dictionary);
    this.arrival = new RoutePoint(data.arrival, data.waitTime, 'arrival', this.dictionary);

    if (data.stopOvers) {
      this.stopovers = data.stopOvers.map(stopover => {
        return new RouteStopover(stopover, data.waitTime, this.dictionary);
      });
    }

    const volumeCompany = data.companyCode || data.company;
    if (data.available) this.capacity.available = new VWMeasurements(data.available, volumeCompany);
    if (data.airplane) this.capacity.airplane = new VWMeasurements(data.airplane, volumeCompany);
    if (data.airplaneCapacityCode) this.capacity.code = data.airplaneCapacityCode;
    if (data.load) this.capacity.load = new RaidLoad(data.load, volumeCompany);
  }

  get id () {
    return this.data.raidId;
  }

  get airplane () {
    return this.data.aircraft;
  }

  get company () {
    return this.data.company;
  }

  get number () {
    return this.data.number;
  }

  get fullNumber () {
    return `${this.company}${this.number}`;
  }

  get departure () {
    return this.departure;
  }

  get arrival () {
    return this.arrival;
  }

  get capacity () {
    return this.capacity;
  }

  get tripTime () {
    return this.data.flightTime;
  }

  get waitTime () {
    return this.data.waitTime;
  }

  get tripTimePretty () {
    return unixTimeToStr(this.tripTime, 'letters');
  }

  get waitTimePretty () {
    return unixTimeToStr(this.waitTime, 'letters');
  }

  get fullName () {
    return `${this.fullNumber} | ${this.departure.airport}-${this.arrival.airport}`;
  }

  get isLastInSegment () {
    return this.data.last;
  }
};
